var map = {
	"./affix/style/index.tsx": 987,
	"./alert/style/index.tsx": 989,
	"./anchor/style/index.tsx": 991,
	"./auto-complete/style/index.tsx": 993,
	"./avatar/style/index.tsx": 998,
	"./back-top/style/index.tsx": 1000,
	"./badge/style/index.tsx": 1002,
	"./breadcrumb/style/index.tsx": 1004,
	"./button/style/index.tsx": 190,
	"./calendar/style/index.tsx": 1006,
	"./card/style/index.tsx": 1009,
	"./carousel/style/index.tsx": 1012,
	"./cascader/style/index.tsx": 1014,
	"./checkbox/style/index.tsx": 193,
	"./col/style/index.tsx": 1017,
	"./collapse/style/index.tsx": 1018,
	"./date-picker/style/index.tsx": 1020,
	"./divider/style/index.tsx": 1023,
	"./dropdown/style/index.tsx": 912,
	"./form/style/index.tsx": 1026,
	"./grid/style/index.tsx": 367,
	"./icon/style/index.tsx": 1028,
	"./input-number/style/index.tsx": 1029,
	"./input/style/index.tsx": 113,
	"./layout/style/index.tsx": 1031,
	"./list/style/index.tsx": 1033,
	"./locale-provider/style/index.tsx": 1037,
	"./mention/style/index.tsx": 1039,
	"./menu/style/index.tsx": 1041,
	"./message/style/index.tsx": 1044,
	"./modal/style/index.tsx": 1046,
	"./notification/style/index.tsx": 1048,
	"./pagination/style/index.tsx": 369,
	"./popconfirm/style/index.tsx": 1050,
	"./popover/style/index.tsx": 913,
	"./progress/style/index.tsx": 914,
	"./radio/style/index.tsx": 365,
	"./rate/style/index.tsx": 1053,
	"./row/style/index.tsx": 1055,
	"./select/style/index.tsx": 192,
	"./slider/style/index.tsx": 1056,
	"./spin/style/index.tsx": 368,
	"./steps/style/index.tsx": 1058,
	"./switch/style/index.tsx": 1060,
	"./table/style/index.tsx": 1062,
	"./tabs/style/index.tsx": 910,
	"./tag/style/index.tsx": 1064,
	"./time-picker/style/index.tsx": 911,
	"./timeline/style/index.tsx": 1066,
	"./tooltip/style/index.tsx": 363,
	"./transfer/style/index.tsx": 1068,
	"./tree-select/style/index.tsx": 1070,
	"./tree/style/index.tsx": 1072,
	"./upload/style/index.tsx": 1074,
	"./version/style/index.tsx": 1076
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 986;


//////////////////
// WEBPACK FOOTER
// ./components ^\.\/[^_][\w-]+\/style\/index\.tsx?$
// module id = 986
// module chunks = 1